import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Titles from "./tabs/Titles";
import { Wrapper } from "../styled";

const titlesAwardsTabs = [
{
    title: "Звания и награды",
    component: <Titles/>,
}
];

const TitlesAwards: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {titlesAwardsTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {titlesAwardsTabs[tab].component}
    </Wrapper>
);
};

export default TitlesAwards;
